import axios from "axios";

export const api = axios.create({
  // baseURL: "http://localhost:3333",
  baseURL: "https://dcifiscal.dcisuporte.com.br/",
  headers: {
    // "cod_cliente": "default"
    "cod_cliente": "enxovaislivia"
  }
});